import request from "@/utils/request";


export function listNotice(query) {
    return request({
        url: '/h5/notice/list',
        method: 'get',
        params: query
    })
}

// 查询推送信息详情
export function getNoticeById(id) {
    return request({
        url: '/h5/notice/'+id,
        method: 'get',
    })
}

// 删除推送信息
export function delNoticeById(id) {
    return request({
        url: '/h5/notice/' + id,
        method: 'delete'
    })
}

// 已读推送信息
export function upNoticeById(query) {
    return request({
        url: '/h5/notice/upNoticeById',
        method: 'put',
        params: query
    })
}
